import * as prodEnvironment from './environment-prod';
import * as testEnvironment from './environment-test';

import { ProfileCookies } from 'src/common/types';
import { isDevRuntime, isTestRuntime } from '../common/utils';
import { SnowplowAnalyticsProperties } from './appTypings';

export const areenaApi = isTestRuntime()
  ? testEnvironment.areenaApi
  : prodEnvironment.areenaApi;

export const areenaAppConf = isTestRuntime()
  ? testEnvironment.areenaAppConf
  : prodEnvironment.areenaAppConf;

export const locationsApi = isTestRuntime()
  ? testEnvironment.locationsApi
  : prodEnvironment.locationsApi;

export const mediaApiUrl = isTestRuntime()
  ? testEnvironment.mediaApiUrl
  : prodEnvironment.mediaApiUrl;

export const consentApiUrl = isTestRuntime()
  ? testEnvironment.consentApiUrl
  : prodEnvironment.consentApiUrl;

export const myOhjelmatDevIP = prodEnvironment.myOhjelmatDevIP;

export const profilesLocalStorageKey = isTestRuntime()
  ? testEnvironment.profilesLocalStorageKey
  : prodEnvironment.profilesLocalStorageKey;

export const searchHistoryLocalStorageKey = isTestRuntime()
  ? testEnvironment.searchHistoryStorageKey
  : prodEnvironment.searchHistoryStorageKey;

export const cloudinaryHostname = isTestRuntime()
  ? testEnvironment.cloudinaryHostname
  : prodEnvironment.cloudinaryHostname;

export const yleLoginCookieKey: keyof ProfileCookies = isTestRuntime()
  ? 'yletestlogin'
  : 'ylelogin';

export const muxEnvKeyDevelopment = 'gfjn4cqp8570eepnkrnviqsjj';

export const tunnusUrl = isTestRuntime()
  ? testEnvironment.tunnusUrl
  : prodEnvironment.tunnusUrl;

export const rememberLastProfileLocalStorageKey = isTestRuntime()
  ? testEnvironment.rememberLastProfileLocalStorageKey
  : prodEnvironment.rememberLastProfileLocalStorageKey;

export const snowplowAnalyticsProperties: SnowplowAnalyticsProperties =
  isTestRuntime() || isDevRuntime()
    ? testEnvironment.snowplowAnalyticsProperties
    : prodEnvironment.snowplowAnalyticsProperties;
